import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const CheckIcon = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 16 16' className={className}>
    <path d="M6.80469 12.832C6.60547 12.832 6.43164 12.7383 6.2832 12.5508L3.42383 8.95312C3.37695 8.89062 3.33984 8.83008 3.3125 8.77148C3.28906 8.70898 3.27734 8.64648 3.27734 8.58398C3.27734 8.44727 3.32227 8.33594 3.41211 8.25C3.50195 8.16016 3.61719 8.11523 3.75781 8.11523C3.92578 8.11523 4.06836 8.19727 4.18555 8.36133L6.78125 11.6953L11.8262 3.69141C11.8887 3.59766 11.9512 3.53125 12.0137 3.49219C12.0762 3.45312 12.1562 3.43359 12.2539 3.43359C12.3906 3.43359 12.5 3.47656 12.582 3.5625C12.668 3.64844 12.7109 3.75977 12.7109 3.89648C12.7109 3.95117 12.7012 4.00781 12.6816 4.06641C12.6621 4.125 12.6309 4.19141 12.5879 4.26562L7.29688 12.5625C7.17578 12.7422 7.01172 12.832 6.80469 12.832Z" fill="#068968"/>
  </SvgIcon>
);

export default CheckIcon;
